import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-opp-item',
    template: ` <div class="cmps-coaching-opportunity-item--label">
            {{ label }}
        </div>
        <div class="cmps-coaching-opportunity-item--scores">
            <div
                class="cmps-coaching-opportunity-item--goal"
                [style.backgroundColor]="goalColour"
                [style.border-color]="goalBorderColour"
            >
                <span
                    [style.color]="goalLabelColour"
                    *ngIf="goalLabel"
                    >{{ goalLabel }}</span
                >
                <cmps-icon
                    [svgIcon]="goalIcon"
                    *ngIf="goalIcon && !goalLabel"
                ></cmps-icon>
                <div
                    class="cmps-coaching-opportunity-item--badge"
                    [style.background-color]="goalBadgeColour"
                    *ngIf="goalBadgeLabel"
                >
                    <span [style.color]="goalBadgeLabelColour">{{
                        goalBadgeLabel
                    }}</span>
                </div>
            </div>
            <div
                class="cmps-coaching-opportunity-item--target"
                [style.color]="targetColour"
            >
                <span>{{ targetLabel }}</span>
            </div>
        </div>`,
    host: {
        class: 'cmps-coaching-opportunity-item',
        '[class.cmps-coaching-opportunity-item--active]': 'active',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsOpportunityItemComponent {
    @Input() label: string;
    @Input() goalBorderColour: string;
    @Input() goalColour: string;
    @Input() goalLabel: string;
    @Input() goalLabelColour: string;
    @Input() goalIcon: string;
    @Input() goalBadgeColour: string;
    @Input() goalBadgeLabel: string;
    @Input() goalBadgeLabelColour: string;
    @Input() targetColour: string;
    @Input() targetLabel: string;
    @Input() active: boolean;
}
